import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BRAND } from "../data/content";

const EASE = [0.16, 1, 0.3, 1];

export default function LoadingScreen({ onDone }) {
  const [count, setCount] = useState(0);
  const [exit, setExit] = useState(false);

  useEffect(() => {
    const duration = 2400;
    const start = performance.now();
    let timer;
    let finished = false;

    const finish = () => {
      if (finished) return;
      finished = true;
      setCount(100);
      setTimeout(() => setExit(true), 450);
      setTimeout(() => onDone && onDone(), 1200);
    };

    const tick = () => {
      const p = Math.min((performance.now() - start) / duration, 1);
      setCount(Math.floor(p * 100));
      if (p >= 1) finish();
      else timer = setTimeout(tick, 40);
    };
    timer = setTimeout(tick, 40);

    // Hard safety net in case timers are throttled/paused
    const safety = setTimeout(finish, duration + 1500);
    return () => {
      clearTimeout(timer);
      clearTimeout(safety);
    };
  }, [onDone]);

  return (
    <AnimatePresence>
      {!exit && (
        <motion.div
          data-testid="loading-screen"
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gk-black"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <div className="ambient-emerald" style={{ width: 420, height: 420, top: "30%", left: "50%", transform: "translateX(-50%)" }} />
          <motion.img
            src={BRAND.logo}
            alt="GK Brandify"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: EASE }}
            className="relative z-10 w-28 h-28 md:w-36 md:h-36 object-contain rounded-2xl mb-8"
          />
          <div className="relative z-10 text-center">
            <p className="font-cinzel text-xl md:text-2xl tracking-[0.3em] text-gold-metallic">
              GK BRANDIFY
            </p>
            <p className="font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase text-white/40 mt-3">
              Building Brands. Shaping the Future.
            </p>
          </div>
          <div className="relative z-10 mt-12 w-56 md:w-72">
            <div className="h-px w-full bg-white/10 overflow-hidden">
              <motion.div
                className="h-full bg-gradient-to-r from-gk-gold to-gk-champagne"
                style={{ width: `${count}%` }}
              />
            </div>
            <div className="flex justify-between mt-3 font-inter text-[10px] tracking-[0.3em] text-white/40">
              <span>LOADING</span>
              <span className="text-gk-gold">{count}%</span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
